/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: production.fga
 * Run: pnpm run gen:permissions -- production
 */

import type { ModulePermissions } from './types';

export const productionPermissions = {
  module: 'production',
  displayName: 'Production',
  entities: [
    {
      name: 'inboundTollingAgreement',
      displayName: 'Inbound Tolling Agreement',
      permissions: [
        {
          key: 'inboundTollingAgreementRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'inboundTollingAgreementCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'inboundTollingAgreementUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'inboundTollingAgreementDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'outboundTollingAgreement',
      displayName: 'Outbound Tolling Agreement',
      permissions: [
        {
          key: 'outboundTollingAgreementRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'outboundTollingAgreementCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'outboundTollingAgreementUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'outboundTollingAgreementDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'processingType',
      displayName: 'Processing Type',
      permissions: [
        { key: 'processingTypeRead', action: 'Read', category: 'crud' },
        { key: 'processingTypeCreate', action: 'Create', category: 'crud' },
        { key: 'processingTypeUpdate', action: 'Update', category: 'crud' },
        { key: 'processingTypeDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'tollReceipt',
      displayName: 'Toll Receipt',
      permissions: [
        { key: 'tollReceiptRead', action: 'Read', category: 'crud' },
        { key: 'tollReceiptCreate', action: 'Create', category: 'crud' },
        { key: 'tollReceiptUpdate', action: 'Update', category: 'crud' },
        { key: 'tollReceiptDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'tollShipment',
      displayName: 'Toll Shipment',
      permissions: [
        { key: 'tollShipmentRead', action: 'Read', category: 'crud' },
        { key: 'tollShipmentCreate', action: 'Create', category: 'crud' },
        { key: 'tollShipmentUpdate', action: 'Update', category: 'crud' },
        { key: 'tollShipmentDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'workOrder',
      displayName: 'Work Order',
      permissions: [
        { key: 'workOrderRead', action: 'Read', category: 'crud' },
        { key: 'workOrderCreate', action: 'Create', category: 'crud' },
        { key: 'workOrderUpdate', action: 'Update', category: 'crud' },
        { key: 'workOrderDelete', action: 'Delete', category: 'crud' },
        { key: 'workOrderCancel', action: 'Cancel', category: 'custom' },
        { key: 'workOrderComplete', action: 'Complete', category: 'custom' },
        { key: 'workOrderOpen', action: 'Open', category: 'custom' },
        { key: 'workOrderStart', action: 'Start', category: 'custom' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Production module
 */
export type ProductionPermissionKey =
  | 'inboundTollingAgreementRead'
  | 'inboundTollingAgreementCreate'
  | 'inboundTollingAgreementUpdate'
  | 'inboundTollingAgreementDelete'
  | 'outboundTollingAgreementRead'
  | 'outboundTollingAgreementCreate'
  | 'outboundTollingAgreementUpdate'
  | 'outboundTollingAgreementDelete'
  | 'processingTypeRead'
  | 'processingTypeCreate'
  | 'processingTypeUpdate'
  | 'processingTypeDelete'
  | 'tollReceiptRead'
  | 'tollReceiptCreate'
  | 'tollReceiptUpdate'
  | 'tollReceiptDelete'
  | 'tollShipmentRead'
  | 'tollShipmentCreate'
  | 'tollShipmentUpdate'
  | 'tollShipmentDelete'
  | 'workOrderRead'
  | 'workOrderCreate'
  | 'workOrderUpdate'
  | 'workOrderDelete'
  | 'workOrderCancel'
  | 'workOrderComplete'
  | 'workOrderOpen'
  | 'workOrderStart';
